'use client';
export default function IubendaLink() {
  return (
    <a
      className="underline font-semibold hover:no-underline hover:cursor-pointer text-sm"
      onClick={() => {
        //@ts-ignore
        window?._iub?.cs?.ui?.openPreferences();
      }}
    >
      Preferenze privacy
    </a>
  );
}
